import styled from '@emotion/styled';
import TextButton from './TextButton';
import colors from '../../../styling/colors';

export default styled(TextButton)`
  color: ${colors('mineshaft')};
  font-size: 1rem;
  margin-top: 1.25rem;
  text-decoration: none;

  span {
    border-bottom: solid 1px;
    padding-bottom: 0.25rem;
    cursor: pointer;
  }
`;
